// 导入自己需要的组件
import {
    Select, Option, OptionGroup, Input, Tree, Dialog, Menu, Col, Row, Dropdown,
    DropdownMenu, Link, Upload, RadioGroup, InputNumber, Radio, Badge, Form,
    FormItem, CheckboxGroup, TimePicker, Tooltip, Cascader, Divider, Slider,
    MenuItemGroup, Table, TableColumn, Popover, Submenu, Container, Aside, Main,


    DatePicker, Button, Checkbox, Loading, Message, Switch,Pagination,table,tag,
    MenuItem,form,MessageBox,  Notification,
} from 'element-ui'

const element = {
    install: function (Vue) {
        Vue.use(Select)
        Vue.use(Option)
        Vue.use(OptionGroup)
        Vue.use(Input)
        Vue.use(Tree)
        Vue.use(Dialog)
        // Vue.use(Row)
        // Vue.use(Col)
        Vue.use(Menu)
        Vue.use(MenuItem)
        Vue.use(MenuItemGroup)
        Vue.use(Table)
        Vue.use(TableColumn)
        Vue.use(Popover)
        Vue.use(Submenu)
        Vue.use(Container)
        Vue.use(Aside)
        Vue.use(Main)
        Vue.use(DatePicker)
        Vue.use(Button)
        Vue.use(Checkbox)
        Vue.use(Pagination)
        Vue.use(table)
        Vue.use(tag)
        Vue.use(Switch)
        Vue.use(Col)
        Vue.use(Row)
        Vue.use(Dropdown)
        Vue.use(DropdownMenu)
        Vue.use(Link)
        Vue.use(Upload)
        Vue.use(RadioGroup)
        Vue.use(InputNumber)
        Vue.use(Radio)
        Vue.use(Badge)
        Vue.use(Form)
        Vue.use(CheckboxGroup)
        Vue.use(TimePicker)
        Vue.use(Tooltip)
        Vue.use(FormItem)
        Vue.use(Cascader)
        Vue.use(Divider)
        Vue.use(Slider)
        // Vue.use(Page)

        //   // Vue.use(Span)
        Vue.use(form)
        Vue.use(Loading.directive);
        Vue.prototype.$loading = Loading.service;
        Vue.prototype.$message = Message;
        Vue.prototype.$alert=MessageBox;
        Vue.prototype.$confirm = MessageBox.confirm;
        Vue.prototype.$notify = Notification;
        Vue.prototype.$msgbox = MessageBox;
        Vue.prototype.$prompt = MessageBox.prompt;
    }
}
export default element
